import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import ReactSVG from "react-svg";
import {
  checkHasNumber,
  checkHasString,
  checkHasSpecialCharacter,
} from "~/utils/tools";

import {
  Margin,
  Input,
  Button,
  Loading,
  ErrorMessage,
  Text,
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";

import errorSVG from "~/assets/img/icon/error.svg";
import successSVG from "~/assets/img/icon/check.svg";

import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

import { Creators as AccountActions } from "~/store/modules/account/actions";

export default function FormUpdatePassword() {
  const dispatch = useDispatch();
  const mobile = isMobile();

  const sending = useSelector((state) => state?.account?.password?.sending);

  const errorMessage = useSelector(
    (state) => state?.account?.password?.errorMessage
  );

  const initialValues = {
    Password: "",
    NewPassword: "",
    ConfirmPassword: "",
  };

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  return (
    <S.FormHolder>
      <Margin mb={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(
              AccountActions.sendPassword({
                url: url,
                origin: origin,
                SenhaAntiga: values.Password,
                Senha: values.NewPassword,
                SenhaNovamente: values.ConfirmPassword,
              })
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={2}>
                <Input
                  label="Contraseña actual"
                  placeholder="Ingrese su contraseña actual"
                  htmlFor="passwordFieldFormUpdatePassword"
                  name="Password"
                  type="password"
                  value={values.Password}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  onBlur={handleBlur}
                  validateOnBlur={false}
                  showPassword={false}
                  required
                />
              </Margin>
              <Margin mb={4}>
                <S.ForgotLink>
                  <Link
                    to="/esqueci-minha-senha"
                    id="forgotLinkFormUpdatePassoword"
                  >
                    Olvidé mi contraseña
                  </Link>
                </S.ForgotLink>
              </Margin>

              <Margin mb={2}>
                <Input
                  label="Nueva contraseña"
                  placeholder="Ingrese su nueva contraseña"
                  htmlFor="newPasswordFieldFormUpdatePassword"
                  name="NewPassword"
                  type="password"
                  value={values.NewPassword}
                  onChange={handleChange}
                  showHidePassword={true}
                  successIcon={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>

              <Margin mb={2}>
                <Input
                  label="Confirmar nueva contraseña"
                  placeholder="Reescribe tu nueva contraseña"
                  htmlFor="confirmNewPasswordFieldFormUpdatePassword"
                  name="ConfirmPassword"
                  type="password"
                  value={values.ConfirmPassword}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>

              <S.PasswordRules>
                <Text level="1">Tu contreseña debe contener:</Text>
                <ul>
                  <li
                    className={
                      values.NewPassword.length === 0 ||
                      values.NewPassword !== values.ConfirmPassword
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        values.NewPassword.length === 0 ||
                        values.NewPassword !== values.ConfirmPassword
                          ? errorSVG
                          : successSVG
                      }
                    />
                    La misma contraseña en los campos Nueva contraseña y
                    Confirmar nueva contraseña
                  </li>
                  <li
                    className={
                      values.NewPassword.length < 8 ||
                      values.NewPassword.length >= 13
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        values.NewPassword.length < 8 ||
                        values.NewPassword.length >= 13
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Mínimo 8 y máximo 12 caracteres
                  </li>
                  <li
                    className={
                      !checkHasString(values.NewPassword) ? "error" : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasString(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Al menos una letra
                  </li>
                  <li
                    className={
                      !checkHasNumber(values.NewPassword) ? "error" : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasNumber(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Al menos un número
                  </li>
                  <li
                    className={
                      !checkHasSpecialCharacter(values.NewPassword)
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasSpecialCharacter(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    {"Al menos un caracter especial (Ej: !#@)"}
                  </li>
                </ul>
              </S.PasswordRules>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Button
                  color={sending ? "disabled" : "primary"}
                  variant="outlined"
                  disabled={sending}
                  onClick={() => history.push("/minha-conta")}
                  id="updateEmailFormReturn"
                >
                  REGRESAR
                </Button>
                <Button
                  className="animation-size"
                  color={!isValid || !dirty || sending ? "disabled" : "primary"}
                  type="submit"
                  disabled={!isValid || !dirty || sending}
                  id="sendButtonFormUpdatePassword"
                >
                  {sending ? <Loading button /> : "ACTUALIZAR"}
                </Button>
              </S.ButtonsGrid>
            </S.FormLimiter>
          )}
        </Formik>
        {errorMessage && (
          <Margin mt={3} mb={3}>
            <ErrorMessage inset>{errorMessage}</ErrorMessage>
          </Margin>
        )}
      </Margin>
    </S.FormHolder>
  );
}
